import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../message";
import CampaignsService from "../../../services/campagins";
import { toast } from "react-toastify";

export const getCampaigns = createAsyncThunk(
  "campagins/getCampagins",
  async ({ page, filterData }, thunkAPI) => {
    try {
      const result = await CampaignsService.getCampaigns(page, filterData);
      if (result) {
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result.data.message));
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteCampaign = createAsyncThunk(
  "campagins/deleteCampaign",
  async (payload, thunkAPI) => {
    try {
      const result = await CampaignsService.deleteCampaign(payload);
      if (result) {
        toast.success("Campaign deleted successfully.");
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result.data.message));
        toast.error("Ops, something went wrong.");
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const cloneCampaign = createAsyncThunk(
  "campagins/cloneCampaign",
  async (payload, thunkAPI) => {
    try {
      const result = await CampaignsService.cloneCampaign(payload);
      if (result) {
        toast.success("Campaign cloned successfully.");
        return result;
      } else {
        toast.error("Ops, something went wrong.");
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const testCampaigns = createAsyncThunk(
  "campaigns/testCampaigns",
  async (payload, thunkAPI) => {
    try {
      const result = await CampaignsService.testCampaign(payload);

      // Assume backend returns: { success: true/false, message: string }
      if (result?.success) {
        thunkAPI.dispatch(setMessage(result.message || "Campaign sent successfully."));
        return result;
      } else {
        const message = result?.message || "Something went wrong!";
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue({ message });
      }
    } catch (error) {
      const message =
        (error?.response?.data?.message ||
          error?.message ||
          "Something went wrong during test campaign.");
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue({ message });
    }
  }
);


export const getTodayCampaigns = createAsyncThunk(
  "campagins/getTodayCampagins",
  async (filterData, thunkAPI) => {
    try {
      const result = await CampaignsService.getTodayCampaigns(filterData);
      if (result) {
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result.data.message));
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

//markCampaignDeleted
export const updateCampaignStatus = createAsyncThunk(
  'campaign-run-report/updateStatus',
  async (payload, thunkAPI) => {
    try {
      const response = await CampaignsService.markCampaignStatus(payload);
      if (response?.success) {
        toast.success(response?.message || "successfully update campaign status.")
        return response?.message || "successfully update campaign status.";
      } else {
        toast.error(response?.message || "Something went wrong. pls try again")
        return thunkAPI.rejectWithValue(response?.message || "Something went wrong. pls try again")
      }
    } catch (err) {
      toast.error(err?.response?.message || "Internal Server Error")
      console.log("Error in markCampaignDeleted : ", err);
      return thunkAPI.rejectWithValue(err?.response?.message || "Internal Server Error");
    }
  }
)

const initialState = { campaigns: null, todayCampaigns: null };

const campaignsSlice = createSlice({
  name: "campaigns",
  initialState,

  extraReducers: {
    [getCampaigns.fulfilled]: (state, action) => {
      state.campaigns = action.payload;
      //return { ...state, defaulters: action.payload.data };
    },
    [getCampaigns.rejected]: (state, action) => {
      state.campaigns = null;
      //return { ...state, defaulters: [] };
    },
    [cloneCampaign.fulfilled]: (state, action) => {
      state.campaigns = action.payload;
      //return { ...state, defaulters: action.payload.data };
    },
    [cloneCampaign.rejected]: (state, action) => {
      state.campaigns = null;
      //return { ...state, defaulters: [] };
    },
    [testCampaigns.rejected]: (state, action) => {
      state.campaigns = null;
      //return { ...state, defaulters: [] };
    },
    [getTodayCampaigns.fulfilled]: (state, action) => {
      state.todayCampaigns = {
        data: action.payload.data,
        // data = { result: [...], totalCount: 123 }
      };
    },
    [getTodayCampaigns.rejected]: (state, action) => {
      state.todayCampaigns = null;
    },
  },
});

export default campaignsSlice.reducer;
